<header class="nav-pill">
    <button type="button" class="nav-burger" *ngIf="isCompact" (click)="toggleDrawer()"
        [attr.aria-expanded]="drawerOpen" aria-label="Toggle navigation">
        <i class="fa-solid" [ngClass]="drawerOpen ? 'fa-xmark' : 'fa-bars'"></i>
    </button>

    <a class="nav-brand" routerLink="/story" (click)="closeDrawer()">
        <span class="header-logo-anim">
            <span class="tri-dots-anim">
                <span class="dot dot-1"></span>
                <span class="line line-1-2"></span>
                <span class="dot dot-2"></span>
                <span class="line line-2-3"></span>
                <span class="dot dot-3"></span>
            </span>
        </span>
        <span class="brand-title">LIAM</span>
    </a>

    <!-- Sections, always visible: a segmented track so five chips read as one
         control rather than five more things in the bar -->
    <div class="section-track" *ngIf="showSections && !isCompact">
        <div class="chip-wrap" *ngFor="let item of sectionGroup.items"
            [class.has-open-menu]="openSubMenu === item.label">

            <a class="section-chip" [class.is-current]="isActive(item)" routerLink="/login"
                [queryParams]="{ scrollTo: item.section }" (click)="onSectionClick(item)">
                <span>{{ item.label }}</span>
                <span *ngIf="item.children" class="chip-caret" role="button" tabindex="0"
                    [attr.aria-label]="(openSubMenu === item.label ? 'Close ' : 'Open ') + item.label + ' menu'"
                    (click)="toggleSubMenu(item, $event)" (keydown.enter)="toggleSubMenu(item, $event)">
                    <i class="fa-solid fa-chevron-down chev" [class.flip]="openSubMenu === item.label"></i>
                </span>
            </a>

            <div class="chip-menu" *ngIf="item.children && openSubMenu === item.label">
                <a *ngFor="let child of item.children" class="chip-menu-item"
                    [class.is-current]="activeSection === child.section" routerLink="/login"
                    [queryParams]="{ scrollTo: child.section }" (click)="onSectionClick(child)">
                    <i [ngClass]="child.icon" aria-hidden="true"></i>
                    <span>{{ child.label }}</span>
                </a>
            </div>
        </div>
    </div>

    <span class="pill-spacer"></span>

    <nav class="pill-links" *ngIf="!isCompact">
        <a *ngFor="let item of pageGroup.items" class="pill-link" [ngClass]="'accent-' + item.accent"
            [routerLink]="item.route" routerLinkActive="is-current" [routerLinkActiveOptions]="{ exact: true }">
            <i [ngClass]="item.icon" aria-hidden="true"></i>
            <span>{{ item.label }}</span>
        </a>
    </nav>

    <a class="btn-nav-signin" routerLink="/login" (click)="closeDrawer()">Sign In</a>
</header>

<!-- Below COMPACT_WIDTH the pill has no room for either list, so both move here -->
<div class="nav-scrim" *ngIf="isCompact && drawerOpen" (click)="closeDrawer()"></div>

<aside class="site-nav" *ngIf="isCompact" [class.is-open]="drawerOpen">
    <nav class="nav-groups">
        <div class="nav-group" *ngFor="let group of drawerGroups">

            <button type="button" class="nav-group-head" (click)="toggleGroup(group.key)"
                [attr.aria-expanded]="openGroups[group.key]">
                <span>{{ group.label }}</span>
                <i class="fa-solid fa-chevron-down chev" [class.flip]="openGroups[group.key]"></i>
            </button>

            <ul class="nav-list" *ngIf="openGroups[group.key]">
                <li *ngFor="let item of group.items">

                    <a *ngIf="item.section" class="nav-item" [class.is-current]="isActive(item)"
                        routerLink="/login" [queryParams]="{ scrollTo: item.section }"
                        (click)="onSectionClick(item)">
                        <i [ngClass]="item.icon" aria-hidden="true"></i>
                        <span class="nav-label">{{ item.label }}</span>
                        <span *ngIf="item.children" class="sub-toggle" role="button" tabindex="0"
                            [attr.aria-label]="(isItemOpen(item) ? 'Collapse ' : 'Expand ') + item.label"
                            (click)="toggleItem(item, $event)" (keydown.enter)="toggleItem(item, $event)">
                            <i class="fa-solid fa-chevron-down chev" [class.flip]="isItemOpen(item)"></i>
                        </span>
                    </a>

                    <a *ngIf="item.route" class="nav-item" [ngClass]="'accent-' + item.accent"
                        [routerLink]="item.route" routerLinkActive="is-current"
                        [routerLinkActiveOptions]="{ exact: true }" (click)="closeDrawer()">
                        <i [ngClass]="item.icon" aria-hidden="true"></i>
                        <span class="nav-label">{{ item.label }}</span>
                    </a>

                    <ul class="nav-sublist" *ngIf="item.children && isItemOpen(item)">
                        <li *ngFor="let child of item.children">
                            <a class="nav-subitem" [class.is-current]="activeSection === child.section"
                                routerLink="/login" [queryParams]="{ scrollTo: child.section }"
                                (click)="onSectionClick(child)">
                                <i [ngClass]="child.icon" aria-hidden="true"></i>
                                <span class="nav-label">{{ child.label }}</span>
                            </a>
                        </li>
                    </ul>

                </li>
            </ul>
        </div>
    </nav>
</aside>

<!-- "Your apps" - the connector pitch, on screen at every scroll depth.
     Lives here so all four public pages that use this nav get it. -->
<app-connect-apps-dock *ngIf="showDock"></app-connect-apps-dock>
